import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as partnerCategoryActions from '../../actions/partner-categories';
import Select from '../form/select';
import LocalizedStrings from '../../localization/strings';

class PartnerCategorySelection extends Component {

    componentDidMount() {
        this.props.actions.fetchAllPartnerCategories();
    }

    render() {
        const {field} = this.props;

        return (<Select
                  clearable={false}
                  options={this.props.categories.partnerCategories.items}
                  noResultsText={LocalizedStrings.noCategories}
                  placeholder={LocalizedStrings.partnerCategory}
                  {...field}
                  onChange={(item)=>{
                    field.onChange(item.value)
                  }}/>
        )
    }
}

export default connect(function (state) {
    return {categories: state.partnerCategories}
}, function (dispatch) {
    return {
        actions: bindActionCreators(partnerCategoryActions, dispatch)
    }
})(PartnerCategorySelection);



// WEBPACK FOOTER //
// ./src/js/components/partner-category/partner-category-select.js